module.exports = __webpack_public_path__ + "static/media/twsHiFi.645891ca.png";